// extracted by mini-css-extract-plugin
module.exports = {"top":"About_top__S5Vlq","content":"About_content__dY8RO","hide":"About_hide__5dpNW","show":"About_show__Ntlw8","avatar":"About_avatar__q_K0b","welcome":"About_welcome__6I6vT"};